import { render, staticRenderFns } from "./BlockListRow.vue?vue&type=template&id=6d5371a1&scoped=true"
import script from "./BlockListRow.vue?vue&type=script&lang=js"
export * from "./BlockListRow.vue?vue&type=script&lang=js"
import style0 from "./BlockListRow.vue?vue&type=style&index=0&id=6d5371a1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d5371a1",
  null
  
)

export default component.exports